import FJDragBox from '../../../../common/components/FJDragBox/FJDragBox';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import styles from './FJVideoRemoveBgRight.module.less';
import PropTypes from 'prop-types';
import FJBlankInVideoPanel from '../../../FJMainPreview/FJBlankPanel/FJBlankInVideoPanel';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import FJVideoRemovePreviewBoxContainer from '../container/FJVideoRemovePreviewBoxContainer';
import FJVideoRemoveBgControlsContainer from '../container/FJVideoRemoveBgControlsContainer';
import FJVideoRemoveBgCustomAfterContainer from '../container/FJVideoRemoveBgCustomAfterContainer';
import FJConstant from '../../../../constants/FJConstant';
import classNames from 'classnames';
import FJVideoRemoveBgAutoRightContainer from '../container/FJVideoRemoveBgAutoRightContainer';
import { useMemo } from 'react';
import FJCustomVideoRemoveBgProgressContainer from '../container/FJCustomVideoRemoveBgProgressContainer';
import FJConfig from '../../../../config/FJConfig';

const FJVideoRemoveBgRight = ({
    editVideoInfo,
    autoEditVideoInfo,
    headerTabIndex,
    curMenuIndex,
    customRemoverStep,
    customRemoverStatus,
    autoRemoverStatus,
}) => {
    const isShowBlank = useMemo(() => {
        return (
            headerTabIndex === 0 &&
            ((!editVideoInfo && customRemoverStep === 0 && curMenuIndex === 1) ||
                (!autoEditVideoInfo && curMenuIndex === 0 && autoRemoverStatus === FJConstant.DEFAULT))
        );
    }, [headerTabIndex, editVideoInfo, customRemoverStep, autoEditVideoInfo, curMenuIndex, autoRemoverStatus]);

    return (
        <FJDragBox className={classNames(styles.app_right)}>
            <FJDisplayHeaderContainer isShowProgress={false} />

            <div
                className={classNames(styles.video_remove_bg_right, {
                    [styles.video_remove_bg_right_hide]: headerTabIndex !== 0,
                })}
            >
                <FJBlankInVideoPanel
                    active={isShowBlank}
                    boxTitle={curMenuIndex === 0 ? FJConfig.autoNotVideoBoxTitle : FJConfig.notImageBoxTitle}
                    boxDesc={curMenuIndex === 0 ? FJConfig.autoNotVideoBoxDesc : FJConfig.notImageBoxDesc}
                />

                {curMenuIndex === 0 && <FJVideoRemoveBgAutoRightContainer />}

                {curMenuIndex === 1 && (
                    <>
                        {customRemoverStatus !== FJConstant.DEFAULT && <FJCustomVideoRemoveBgProgressContainer />}

                        {customRemoverStep === 0 && (
                            <>
                                {customRemoverStatus === FJConstant.DEFAULT && <FJVideoRemovePreviewBoxContainer />}
                                <FJVideoRemoveBgControlsContainer />
                            </>
                        )}
                        {customRemoverStep === 1 && <FJVideoRemoveBgCustomAfterContainer />}
                    </>
                )}
            </div>

            <FJHistoryPanelContainer activeHeaderTabIndex={1} />
        </FJDragBox>
    );
};

FJVideoRemoveBgRight.propTypes = {
    editVideoInfo: PropTypes.object,
    headerTabIndex: PropTypes.number,
    customRemoverStep: PropTypes.number,
    customRemoverStatus: PropTypes.string,
    curMenuIndex: PropTypes.number,
    autoEditVideoInfo: PropTypes.object,
    autoRemoverStatus: PropTypes.string,
};

export default FJVideoRemoveBgRight;
